import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { BaseService } from "../../@core/services/base.service";
import { environment } from "../../../environments/environment.dev";
import { IFile } from "../../@core/models/model";
import { KNOWLEDGE_SCOPE } from "../models/contract-management.model";



@Injectable({ providedIn: 'root' })
export class RepositoryService extends BaseService {

    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }

    apiUrl = environment.apiUrl + '/repository';
    parentFolderId: string | null = null

    getParentFolderId() {
        return this.parentFolderId;
    }

    getFiles(params?: { project?: string; scope?: KNOWLEDGE_SCOPE; type?: KNOWLEDGE_SCOPE }) {
        return this.get<IFile[]>(this.apiUrl, params)
    }

    getFolderDetails(folderId: string) {
        return this.get<(IFile & { childs: IFile[] })>(this.apiUrl + '/folder/' + folderId)
    }

    getDocTypeFiles(docTypeId: string, filters: { search: string, skip: number, limit: number, reqOnlyFiles?: boolean }) {
        return this.post<{
            files: IFile[],
            total: number
        }>(this.apiUrl + '/get-doc-type-files', { docTypeId, filters })
    }

    getAnyDocTypeFiles(filters: { search: string, skip: number, limit: number, reqOnlyFiles?: boolean, scope?: string, project?: string }) {
        return this.post<{
            files: IFile[],
            total: number
        }>(this.apiUrl + '/get-doc-type-files', { filters })
    }

    uploadFiles(formData: FormData) {
        return this.post<any>(this.apiUrl + '/upload-file', formData)
    }

    deleteFile(fileIds: string | string[]) {
        return this.delete<IFile>(this.apiUrl + '/file/', { fileIds, parentFolderId: this.parentFolderId })
    }

    downloadRepoFiles(fileIds: IFile['_id'][]) {
        return this.post<{ data: Buffer }>(this.apiUrl + '/download-repo-files', { fileIds })
    }

    linkToKnowledgeBase(selectedKnowledgeBases: string[], selectedFiles?: string[], contractIds?: string[], projectIds?: string[]) {
        return this.post<any>(this.apiUrl + '/link-to-knowledge-base', {
            knowledgeBaseIds: selectedKnowledgeBases,
            ...(selectedFiles && selectedFiles.length > 0 && { fileIds: selectedFiles }),
            ...(contractIds && contractIds.length > 0 && { contractIds: contractIds }),
            ...(projectIds && projectIds.length > 0 && { projectIds: projectIds })
        })
    }
}
